export const MONTHLY_LIMIT_TO_BE_EARNED = 12000

interface IGetNolPointsToBeEarned {
  nolPoints: number
  isMax: boolean
}

/**
 * @desc  적립 예정 놀포인트를 반환하는 함수
 *
 * @param   amountToPay 결제 예정 금액
 *
 * @return  Object
 * @return  points  적립 예정 금액
 * @return  isMax   월 별 최대 적립가능금액 이상 여부
 * */
const getNolPointsToBeEarned = (amountToPay: number): IGetNolPointsToBeEarned => {
  return {
    nolPoints: Math.min(MONTHLY_LIMIT_TO_BE_EARNED, Math.round(amountToPay * 0.1)),
    isMax: MONTHLY_LIMIT_TO_BE_EARNED <= amountToPay * 0.1,
  }
}

export default getNolPointsToBeEarned
